<template>
  <MessageItem
    :date="message.createdAt"
    :userType="userType"
    :personalityType="personalityType"
    :isReadByUser="isReadByUser"
    @clickUserThumbnail="$emit('clickUserThumbnail')"
  >
    <ul :class="$style.answers">
      <li
        :class="$style.answers__item"
        v-for="answer in message.selectedAnswers"
        :key="answer.id"
      >
        <!-- prettierがここを改行してしまって、文字の前に半角スペースが入るため、コメントで回避している -->{{
          answer.selection
        }}<!-- -->
      </li>
    </ul>
  </MessageItem>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import MessageItem from '@/components/molecules/MessageItem.vue'
import type { AnswerMessage } from '@/types/app/message'
import type { ChatMessageUserType } from './ChatMessageUserType'
import type { PersonalityType } from '@/types/app'

export default defineComponent({
  name: 'ChatMessageAnswer',
  components: {
    MessageItem,
  },
  props: {
    message: {
      type: Object as PropType<AnswerMessage>,
      required: true,
    },
    personalityType: {
      type: String as PropType<PersonalityType>,
      default: 'A',
    },
    isReadByUser: {
      type: Boolean,
      default: false,
    },
    userType: {
      type: String as PropType<ChatMessageUserType>,
      required: true,
    },
  },
})
</script>

<style lang="scss" module>
.answers {
  padding: 24px;
  padding-left: 2.8em;
  white-space: pre-wrap;
  word-break: break-all;

  &__item {
    list-style: circle;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}
</style>
